import { Box } from "@mui/material";
import React from "react";
import MHButton from "../Common/Button/MHButton";
import { useHistory } from "react-router-dom";
import Typography, { typographyClasses } from "@mui/material/Typography";

type Props = {};

const TakeSurvey = (props: Props) => {
  let history = useHistory();
  return (
    <React.Fragment>
      <Box
        py={7}
        px={{ xs: 2, md: 6, lg: 8 }}
        bgcolor="primary.main"
        color="#EDD5B1"
        sx={{
          [`& > .${typographyClasses.root}`]: {
            color: "#EDD5B1",
            textAlign: "center",
          },
        }}
      >
        <Typography
          variant="h1"
          fontSize={{ xs: "30px", sm: "40px", md: "50px" }}
          textTransform="capitalize"
          align="center"
          sx={{
            mb: 0,
          }}
          paragraph
        >
          Strengthening Nigeria's Childcare Sector Through <br /> Public-Private
          Partnership
          {/* The Business and Economic Case For Care In Africa */}
        </Typography>
        <Typography
          variant="body1"
          color="primary.main"
          width={{ xs: "100%", md: "70%" }}
          fontSize={{ sm: "14px", md: "16px" }}
          lineHeight={"150%"}
          letterSpacing={"0.02em"}
          align="center"
          mx="auto"
          py="2px"
          paragraph
        >
          Nigeria is on the verge of a demographic shift that demands urgent
          action: by 2040, it will become the third most populous country
          globally, with half its population under 15. The implications for
          early childhood care are profound. The Abuja Childcare Growth Lab,
          co-hosted by Caring Africa, UN Women, The Baby Lounge, Women Affairs
          FCT, brought together 30+ key government and regulatory stakeholders
          to address the systemic breakdowns in the country's childcare
          infrastructure, and discuss pathways to strengthen licensing, quality,
          and delivery of childcare in Nigeria.
          {/* At the Caring Africa Summit, we presented the business case for care
          report. This groundbreaking document underscores the integral role of
          care in driving economic prosperity across the continent. Drawing on
          expert opinions, case studies, and empirical data, the report
          highlights the potential for significant economic returns, improved
          workforce productivity, and enhanced quality of life. */}
        </Typography>

        <Box className="mx-auto text-center py-10 md:py-8">
          <MHButton
            onClick={() => history.push("/policy-brief")}
            // onClick={() =>
            //   window.open(
            //     "https://issuu.com/mhworklife/docs/the_business_case_for_care_2024-compressed"
            //   )
            // }
            // onClick={() => window.open("https://form.typeform.com/to/eLJqW2tq")}
            color="secondary"
            className="capitalize text-[10px] md:text-[10px] lg:text-[12px] leading-[102%] tracking-[0.05em] w-[160px] md:w-[160px] lg:w-[176px] md:h-[50px] lg:h-[52px] py-5"
          >
            {/* Take The Survey */}
            View Policy Brief
          </MHButton>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default TakeSurvey;
